import { render, staticRenderFns } from "./StepperFooter.vue?vue&type=template&id=59ed3468&scoped=true&"
import script from "./StepperFooter.vue?vue&type=script&lang=js&"
export * from "./StepperFooter.vue?vue&type=script&lang=js&"
import style0 from "./StepperFooter.vue?vue&type=style&index=0&id=59ed3468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed3468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ed3468')) {
      api.createRecord('59ed3468', component.options)
    } else {
      api.reload('59ed3468', component.options)
    }
    module.hot.accept("./StepperFooter.vue?vue&type=template&id=59ed3468&scoped=true&", function () {
      api.rerender('59ed3468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StepperFooter.vue"
export default component.exports